module.exports = __webpack_public_path__ + "img/ic-password-lock.c380ebf2.svg";